import { useGetOwnCorporation } from '~/features/userStructures/hooks/corporation/useGetOwnCorporation';
import { findOwnDivisionPhoneNumberId } from '~/features/whatsapp/utils/findOwnDivisionPhoneNumberId';
import useUserInfo from '~/hooks/useUserInfo';

// null/undefined while loading, for users without division (admin) or divisions without number
export const useOwnDivisionPhoneNumberId = (): string | null | undefined => {
    const user = useUserInfo();
    const { data: corporation } = useGetOwnCorporation();

    return findOwnDivisionPhoneNumberId(corporation, user?.divisionId);
};
